export default "__VITE_ASSET__BupM_AAw__"